// extracted by mini-css-extract-plugin
module.exports = {"button":"a10a3f92e9--button--z2WrC","button-left":"a10a3f92e9--button-left--KrrcC","button-right":"a10a3f92e9--button-right--cK1Ha"};